import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";

const studyAbroadCountries = [
  { value: "USA", label: "USA" },
  { value: "UK", label: "UK" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Dubai", label: "Dubai" },
  { value: "Ireland", label: "Ireland" },
  { value: "Germany", label: "Germany" },
  { value: "France", label: "France" },
  { value: "Sweden", label: "Sweden" },
  { value: "Singapore", label: "Singapore" },
  { value: "Other", label: "Other" },
];

const monthOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

// Generate years from a start year to the current year + 10 years

const CreateLeadProfileBuildingForm = ({
  mode,
  formData,
  setFormData,
  handleChange,
  sectionsRef,
}) => {
  const [intakeMonth, setIntakeMonth] = useState(null);
  const [intakeYear, setIntakeYear] = useState(null);
  const [displayIntake, setDisplayIntake] = useState(""); // Separate state for display

  // const sectionsRef = {
  //   leadInfo: useRef(null),
  //   referralSource: useRef(null),
  //   educationCareer: useRef(null),
  //   attributesHobbies: useRef(null),
  //   careerIntrests: useRef(null),
  //   technologyInnovation: useRef(null),
  //   examTestPrep: useRef(null),
  //   parentInformation: useRef(null),
  //   selfDescription: useRef(null),
  //   visa: useRef(null),
  // };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  // const handleCheckboxChange = (event) => {
  //   const { id, checked } = event.target;
  //   if (formData.studyAbroadCountries && formData.reference_source) {
  //     // Check if the checkbox belongs to `studyAbroadCountries`
  //     if (Object.keys(formData.studyAbroadCountries).includes(id)) {
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         studyAbroadCountries: {
  //           ...prevData.studyAbroadCountries,
  //           [id]: checked, // Update the specific country checkbox
  //         },
  //       }));
  //     }
  //     // Check if the checkbox belongs to `referralSources`
  //     else if (Object.keys(formData.reference_source).includes(id)) {
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         reference_source: {
  //           ...(prevData?.reference_source || {}), // Ensure reference_source is an object before modifying
  //           [id]: checked,
  //         },
  //       }));
  //     }
  //   }
  // };

  const handleMultiSelectChange = (selectedOptions, fieldName) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: values,
    }));
  };

  // Change in countries
  const handleCountryChange = (selectedOptions) => {
    const selectedCountries = selectedOptions.map((option) => option.value);
    setFormData({
      ...formData,
      countries_for_abroad_studies: selectedCountries,
    });
  };

  const handleOtherCountry = (e) => {
    setFormData({
      ...formData,
      other_countries_abroad: e.target.value,
    });
  };

  const handleAddOtherCountry = () => {
    if (formData.other_countries_abroad.trim()) {
      const newCountry = {
        value: formData.other_countries_abroad,
        label: formData.other_countries_abroad,
      };
      studyAbroadCountries.push(newCountry);
      setFormData({
        ...formData,
        studyAbroadCountries: [
          ...formData.preferred_countries,
          formData.other_countries_abroad,
        ],
        other_countries_abroad: "", // Clear the input
      });
    }
  };

  // Tags
  const transformTagsToOptions = (tags) => {
    return (tags || []).map((tag) => ({ label: tag, value: tag }));
  };

  // Transform options from CreatableSelect back to simple tags array
  const transformOptionsToTags = (options) => {
    return options.map((option) => option.value);
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 11 }, (_, index) => {
    const year = currentYear + index;
    return { value: year.toString(), label: year.toString() };
  });

  // const handleMonthChange = (selectedOption) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     intakeMonth: selectedOption ? selectedOption.value : "",
  //   }));
  // };

  // const handleYearChange = (selectedOption) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     intakeYear: selectedOption ? selectedOption.value : "",
  //   }));
  // };

  const updateIntake = (month, year) => {
    if (month && year) {
      const formattedDate = new Date(
        `${year}-${month}-01`
      ).toLocaleDateString();
      setFormData((prevState) => ({
        ...prevState,
        intakeMonth: month,
        intakeYear: year,
        intake: formattedDate, // Store intake as formatted date
      }));
    }
  };

  const handleMonthChange = (selectedOption) => {
    const month = selectedOption ? selectedOption.value : "";
    setFormData((prevState) => ({
      ...prevState,
      intakeMonth: month,
    }));
    updateIntake(month, formData.intakeYear);
  };

  const handleYearChange = (selectedOption) => {
    const year = selectedOption ? selectedOption.value : "";
    setFormData((prevState) => ({
      ...prevState,
      intakeYear: year,
    }));
    updateIntake(formData.intakeMonth, year);
  };
  return (
    <>
      <div
        className="md:col-span-3 space-y-8"
        ref={sectionsRef.educationCareer}
        id="education-career"
      >
        <div className="p-6 border-b-2 border-gray-300">
          <h2 className="text-lg font-semibold text-purple-700 mb-4">
            Education & Career Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              {
                label: "Current Education",
                name: "current_education",
              },
              {
                label: "Previous Education",
                name: "previous_education",
              },
            ].map(({ label, name }) => (
              <div key={name} className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {label}
                </label>
                {mode === "view" ? (
                  <p className="text-gray-700">{formData[name] || "N/A"}</p>
                ) : (
                  <input
                    type="text"
                    name={name}
                    value={formData[name] || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                    placeholder={`Enter ${label.toLowerCase()}`}
                  />
                )}
              </div>
            ))}

            {/* Average GPA/Percentage Selection */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Average GPA/Percentage
              </label>
              {mode === "view" ? (
                <p className="text-gray-700">
                  {formData.gpa_percentage || "N/A"}
                </p>
              ) : (
                <select
                  id="gpa_percentage"
                  name="gpa_percentage"
                  className="w-full border border-gray-300 rounded-md p-2"
                  value={formData.gpa_percentage}
                  onChange={handleChange}
                >
                  <option value="">Select...</option>
                  <option value="percentage">Percentage</option>
                  <option value="gpa">GPA</option>
                </select>
              )}
            </div>

            {/* Conditionally Render Percentage Input */}
            {formData.gpa_percentage === "percentage" && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Enter Percentage
                </label>
                {mode === "view" ? (
                  <p className="text-gray-700">
                    {formData.percentage || "N/A"}
                  </p>
                ) : (
                  <input
                    type="number"
                    name="percentage"
                    value={formData.percentage || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter percentage"
                  />
                )}
              </div>
            )}

            {/* Conditionally Render GPA Input */}
            {formData.gpa_percentage === "gpa" && (
              <div className="mb-4 flex gap-2">
                <div className="w-1/2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Enter GPA
                  </label>
                  {mode === "view" ? (
                    <p className="text-gray-700">{formData.gpa || "N/A"}</p>
                  ) : (
                    <input
                      type="number"
                      step="0.01"
                      name="gpa"
                      value={formData.gpa || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md p-2"
                      placeholder="Enter GPA"
                    />
                  )}
                </div>
                <div className="w-1/2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Out of
                  </label>
                  {mode === "view" ? (
                    <p className="text-gray-700">{formData.out_off || "N/A"}</p>
                  ) : (
                    <input
                      type="number"
                      name="out_off"
                      value={formData.out_off || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md p-2"
                      placeholder="Enter scale (e.g., 10)"
                    />
                  )}
                </div>
              </div>
            )}
          </div>{" "}
          <div className="mb-4 flex gap-2">
            <div className="mb-4 w-1/2">
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="intended_degree"
              >
                Intended Degree
              </label>
              {mode === "view" ? (
                <p className="text-gray-700">
                  {formData.intended_degree || "N/A"}
                </p>
              ) : (
                <select
                  id="intended_degree"
                  name="intended_degree"
                  value={formData.intended_degree}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
                >
                  <option value="">Select Degree</option>
                  <option value="Undergraduate">Undergraduate/Bachelors</option>
                  <option value="PG Diploma">PG Diploma</option>
                  <option value="Masters">Masters</option>
                  <option value="MBA">MBA</option>
                  <option value="PhD">PhD</option>
                  <option value="Medical">Medical </option>
                </select>
              )}
            </div>
            <div className="mb-4 w-1/2">
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="intended_courses"
              >
                Intended Course
              </label>
              {mode === "view" ? (
                <p className="text-gray-700">
                  {formData.intended_courses || "N/A"}
                </p>
              ) : (
                <input
                  type="text"
                  id="intended_courses"
                  name="intended_courses"
                  value={formData.intended_courses || ""}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
                />
              )}
            </div>
          </div>
          <div className="flex">
            <div className="flex flex-col w-1/2">
              <label htmlFor="intake" className="font-semibold">
                Intake you do wish to go for *
              </label>
              <div className="flex space-x-4">
                <div className="">
                  {/* <label htmlFor="intakeMonth" className="font-semibold">
                          Month
                        </label> */}
                  <Select
                    name="intakeMonth"
                    options={monthOptions}
                    onChange={handleMonthChange}
                    value={monthOptions.find(
                      (option) => option.value === intakeMonth
                    )}
                    isSearchable
                    isClearable
                    className="mt-1"
                    required
                    isDisabled={mode === "view"}
                  />
                </div>
                <div className="">
                  {/* <label htmlFor="intakeYear" className="font-semibold">
                          Year
                        </label> */}
                  <Select
                    name="intakeYear"
                    options={yearOptions}
                    onChange={handleYearChange}
                    value={yearOptions.find(
                      (option) => option.value === intakeYear
                    )}
                    isSearchable
                    isClearable
                    className="mt-1"
                    required
                    isDisabled={mode === "view"}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4 flex gap-2 w-1/2">
              <div className="mb-4 w-full">
                <div className="mb-4">
                  <label className="block text-sm text-gray-600 mb-2">
                    Countries
                  </label>
                  <Select
                    isMulti
                    options={studyAbroadCountries}
                    value={studyAbroadCountries.filter((country) =>
                      (formData.countries_for_abroad_studies || []).includes(
                        country.value
                      )
                    )}
                    onChange={handleCountryChange}
                    className="w-full"
                    isDisabled={mode === "view"}
                  />
                </div>

                {/* Input for Other Country */}
              </div>
              {formData.studyAbroadCountries &&
                formData.studyAbroadCountries.includes("Other") && (
                  <div className="mt-4 w-1/2">
                    <label className="block text-sm text-gray-600 mb-2">
                      Specify Country
                    </label>
                    <input
                      type="text"
                      name="otherCountry"
                      value={formData.otherCountry || ""}
                      onChange={handleOtherCountry}
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
                      placeholder="Enter country name"
                    />
                    <button
                      type="button"
                      className="mt-2 bg-purple-600 text-white px-4 py-2 rounded-md"
                      onClick={handleAddOtherCountry}
                    >
                      Add Country
                    </button>
                  </div>
                )}
            </div>
          </div>
          <div className="mt-4">
            <label className="block text-sm text-gray-600 mb-2">
              Any Other Information/Preference
            </label>
            {mode === "view" ? (
              <p className="text-gray-700 whitespace-pre-wrap">
                {formData.other_perfrences || "N/A"}
              </p>
            ) : (
              <textarea
                type="text"
                name="other_perfrences"
                rows={4}
                value={formData.other_perfrences || ""}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Any Other Information/Preference"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLeadProfileBuildingForm;
